export const GoogleSlidesIcon = ({ className }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 48 48" width="64" height="64">
    <path fill="#f4b400" d="M37 45H11a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4h19l11 11v27a4 4 0 0 1-4 4" />
    <path fill="#fada80" d="M40 14H30V4z" />
    <path fill="#bf8f00" d="M30 14h10v1l-11-1" />
    <path
      fill="#f1f1f1"
      d="M31 24H17a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V26a2 2 0 0 0-2-2m-1 12H18v-6h12z"
    />
  </svg>
);
